module.exports = __webpack_public_path__ + "static/media/hero-image2.71c71e65.webp";